'use client';

import { motion } from '@/libs';

import { Button, FormField, InputForm, formatDocument } from '../../../ui';

import { useRecoveryCpfForm, type RecoveryCustomerData } from '../../hooks';

type RecoveryCpfFormProps = {
  onSubmit: (data: RecoveryCustomerData) => void;
  onBackToLogin: () => void;
};

export const RecoveryCpfForm = ({ onSubmit, onBackToLogin }: RecoveryCpfFormProps) => {
  const { control, errors, isLoading, handleSubmit } = useRecoveryCpfForm({
    onSubmitSuccess: onSubmit,
  });

  return (
    <motion.div
      data-cy="user-recovery-cpf-form"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className="flex flex-col gap-4"
    >
      <div className="text-center">
        <h2 className="text-lg font-semibold text-foreground">Recuperar acesso</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Informe o CPF da conta para iniciarmos a verificação de identidade.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        <FormField error={errors.document} label="CPF">
          <InputForm
            control={control}
            name="document"
            placeholder="000.000.000-00"
            formatFunction={formatDocument}
            inputMode="numeric"
            autoComplete="on"
          />
        </FormField>

        <Button
          type="submit"
          loading={isLoading}
          disabled={isLoading}
          loadingText="Buscando cadastro..."
          variant="primary"
          size="large"
          className="h-12 w-full text-base"
        >
          Continuar
        </Button>

        <Button
          type="button"
          variant="link"
          size="regular"
          className="mx-auto"
          onClick={onBackToLogin}
        >
          Voltar ao login
        </Button>
      </form>
    </motion.div>
  );
};
